// extracted by mini-css-extract-plugin
export default {"closeButton":"closeButton_closeButton__Cd2Rc"};